__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "clinicalApp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/cache", "11.11.0", () => (Promise.all([__webpack_require__.e(951), __webpack_require__.e(7175), __webpack_require__.e(9488), __webpack_require__.e(7699)]).then(() => (() => (__webpack_require__(10951))))));
			register("@emotion/hash", "0.9.1", () => (__webpack_require__.e(8940).then(() => (() => (__webpack_require__(68940))))));
			register("@emotion/memoize", "0.8.1", () => (__webpack_require__.e(9797).then(() => (() => (__webpack_require__(38914))))));
			register("@emotion/react", "11.11.0", () => (Promise.all([__webpack_require__.e(649), __webpack_require__.e(4061), __webpack_require__.e(7175), __webpack_require__.e(3304), __webpack_require__.e(7462)]).then(() => (() => (__webpack_require__(10649))))));
			register("@emotion/serialize", "1.1.2", () => (Promise.all([__webpack_require__.e(9488), __webpack_require__.e(125)]).then(() => (() => (__webpack_require__(70125))))));
			register("@emotion/sheet", "1.2.2", () => (__webpack_require__.e(6567).then(() => (() => (__webpack_require__(96567))))));
			register("@emotion/unitless", "0.8.1", () => (__webpack_require__.e(8952).then(() => (() => (__webpack_require__(48952))))));
			register("@emotion/use-insertion-effect-with-fallbacks", "1.0.1", () => (__webpack_require__.e(2561).then(() => (() => (__webpack_require__(82561))))));
			register("@emotion/utils", "1.2.1", () => (__webpack_require__.e(5438).then(() => (() => (__webpack_require__(95438))))));
			register("@emotion/weak-memoize", "0.3.1", () => (__webpack_require__.e(7174).then(() => (() => (__webpack_require__(87174))))));
			register("axios", "0.26.1", () => (__webpack_require__.e(4569).then(() => (() => (__webpack_require__(74569))))));
			register("formik", "2.2.9", () => (() => (__webpack_require__(92506))), 1);
			register("react-bootstrap", "2.5.0-beta.1", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(6705), __webpack_require__.e(2783), __webpack_require__.e(2877), __webpack_require__.e(5042), __webpack_require__.e(6312)]).then(() => (() => (__webpack_require__(52877))))));
			register("react-dom", "18.0.0", () => (() => (__webpack_require__(54164))), 1);
			register("react-intl", "5.25.0", () => (Promise.all([__webpack_require__.e(6893), __webpack_require__.e(1761)]).then(() => (() => (__webpack_require__(21761))))));
			register("react-router-dom", "6.3.0", () => (Promise.all([__webpack_require__.e(390), __webpack_require__.e(1909), __webpack_require__.e(1034)]).then(() => (() => (__webpack_require__(43504))))));
			register("react-router", "6.3.0", () => (Promise.all([__webpack_require__.e(390), __webpack_require__.e(2522)]).then(() => (() => (__webpack_require__(16871))))));
			register("react-toastify", "9.1.2", () => (() => (__webpack_require__(75985))), 1);
			register("react", "18.0.0", () => (() => (__webpack_require__(72791))), 1);
			initExternal(42175);
			initExternal(94670);
			initExternal(38939);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};